import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BmsjHipsterSharedModule } from '../../../shared';
import { GermplasmNameContext } from '../../../entities/germplasm/name/germplasm-name.context';
import { GermplasmAuditService } from '../germplasm-audit.service';
import { GERMPLASM_NAME_AUDIT_ROUTES } from './germplasm-name-audit.route';
import { GermplasmNameAuditComponent, GermplasmNameAuditPopupComponent } from './germplasm-name-audit.component';
import { TruncateSpanComponent } from '../../../shared/util/span-truncate/truncate-span.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild([...GERMPLASM_NAME_AUDIT_ROUTES]),
        TruncateSpanComponent,
    ],
    declarations: [
        GermplasmNameAuditComponent,
        GermplasmNameAuditPopupComponent
    ],
    providers: [
        GermplasmAuditService,
        GermplasmNameContext
    ]
})
export class GermplasmNameAuditModule {
}
